var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallOffOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#1BACE4",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(7 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 26.75,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 26.75,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.382 27.5L7.5 27.5C6.67157288 27.5 6 26.8284271 6 26L6 21.553C6 21.0514874 6.25070509 20.5831723 6.668 20.305L7.968 19.437C8.15268781 19.3138784 8.30774913 19.1513031 8.422 18.961L10.062 16.228C10.334385 15.7742173 10.8257492 15.4975637 11.355 15.499984L13.401 15.499984C13.9277572 15.499984 14.4158956 15.7763634 14.687 16.228L18.755 23M17.201 12.413L22.407 21.594M21 12.5L25.699 20.331M12.622 27.5L21.879 27.5M12 11L14.546 11C14.8421281 11 15.1316214 11.0877153 15.378 11.252L16.873 12.252C17.1193786 12.4162847 17.4088719 12.5039677 17.705 12.504L23.868 12.504C24.4127641 12.5041794 24.9146079 12.7996968 25.179 13.276L28.116 18.562C28.3568968 18.9949121 28.3684982 19.5188491 28.147 19.962L25.561 25.133M15.043 24.392C17.108 23.649 28.304 19.326 28.304 19.326M7.125 20L16.95 20M12.055 2.263L14.305 2.263M17.305 2.263C18.1334271 2.263 18.805 2.93457288 18.805 3.763M18.805 6.763L18.805 9.013M5.68 5.263C5.68 5.05589322 5.51210678 4.888 5.305 4.888M5.305 5.638C5.51210678 5.638 5.68 5.47010678 5.68 5.263M4.93 5.263C4.93 5.47010678 5.09789322 5.638 5.305 5.638M5.305 4.888C5.09789322 4.888 4.93 5.05589322 4.93 5.263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.305,0.763 C7.79028137,0.763 9.805,2.77771863 9.805,5.263 C9.805,7.184 7.117,10.839 5.896,12.401 C5.753863,12.5829205 5.53586359,12.6892436 5.305,12.6892436 C5.07413641,12.6892436 4.856137,12.5829205 4.714,12.401 C3.493,10.84 0.805,7.184 0.805,5.263 C0.805,2.77771863 2.81971863,0.763 5.305,0.763 L5.305,0.763 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOffOrder);
export default __webpack_public_path__ + "static/media/call-off-order.bf7aac9ae9b643e90f08f164d529cfb6.svg";
export { ForwardRef as ReactComponent };